/*
* for use with resources/views/products/_index-update.blade.php to change product status  
*/
import forceCloseModal from "../../core/utils/force-close-modal";

class ProductStatusManager {
    constructor() {
        this.$changeStatusButtons = $('.changeProductStatus');
        this.$confirmPopup = $('#confirmPopup');
        this.$dynamicErrorsContainer = $('#dynamicErrorsContainer');
        this.$dynamicErrors = $('#dynamicErrors');

        this.affectedConfirmBaseUrl = window.app?.routes?.productAffectedConfirm ?? '';
        this.changeStatusBaseUrl = window.app?.routes?.productChangeStatus ?? '';
        this.csrfToken = window.app?.config?.csrfToken;

        // Bind all event listeners
        this.bindEvents();
    }

    /**
     * Binds all necessary event handlers to the DOM elements.
     */
    bindEvents() {
        this.$changeStatusButtons.on('click', (e) => {
            e.preventDefault();
            this.handleChangeProductStatus(e);
        });
    }

    /**
     * Handles the click event for buttons that change a product's status.
     * @param {Event} e The event object from the click.
     */
    handleChangeProductStatus(e) {
        const $button = $(e.currentTarget);
        const status = $button.data('status');
        const id = $button.data('id');
        const type = $button.data('type');

        this.changeProductStatus(id, type, status);
    }

    /**
     * Orchestrates the process of confirming and changing a product's status.
     * It uses helper methods for the confirmation and operation steps.
     * @param {string|number} id The product ID.
     * @param {string} type The product type.
     * @param {string} status The new status.
     */
    changeProductStatus(id, type, status) {
        let url = this.affectedConfirmBaseUrl;
        url = url.replace('PRODUCT_ID', id);
        url = url.replace('TYPE', type);

        const data = {
            _token: this.csrfToken.val()
        };

        this.affectedConfirm(url, data, () => {
            let changeUrl = this.changeStatusBaseUrl;
            changeUrl = changeUrl.replace('PRODUCT_ID', id);
            changeUrl = changeUrl.replace('STATUS', status);

            this.runConfirmedOperation(changeUrl, data, () => {
                location.reload();
            });
        });
    }

    /**
     * Displays a confirmation popup. If there are no affected items,
     * the callback is executed immediately without showing the popup.
     * @param {string} url The URL for the confirmation check.
     * @param {object} data The data to send with the AJAX request.
     * @param {Function} callback The function to execute upon confirmation or if no confirmation is needed.
     */
    affectedConfirm(url, data, callback) {
        $.ajax({
            url: url,
            type: 'POST',
            data: data,
            success: (data) => {
   
                if (data.indexOf("error:") === -1) {
                    const html = $.parseHTML(data);
                    const $htmlWrapper = $("<div/>").html(html);
                    const affectedCount = parseInt($htmlWrapper.find('#affectedCount').val());

                    if (!isNaN(affectedCount) && affectedCount > 0) {
                        $htmlWrapper.find('#confirm').on('click', (event) => {
                            callback();
                            forceCloseModal(this.$confirmPopup);
                        });
                        this.$confirmPopup.html($htmlWrapper.html()).modal('show');
                    } else {
                        // No affected products, so no confirmation is needed.
                        callback();
                    }
                } else {
                    const error = data.replace('error:', '');
                    this.$dynamicErrors.html(`<li>${error}</li>`);
                    this.$dynamicErrorsContainer.show();
                    forceCloseModal(this.$confirmPopup);
                }
            }
        });
    }

    /**
     * Runs the desired operation after a successful confirmation.
     * @param {string} url The URL for the main operation.
     * @param {object} data The data to send with the AJAX request.
     * @param {Function} successCallback The function to execute on a successful operation response.
     */
    runConfirmedOperation(url, data, successCallback) {
        $.ajax({
            url: url,
            type: 'POST',
            data: data,
            success: (data) => {
                const response = JSON.parse(data);
                const isSuccessful = response.hasOwnProperty('status') && response.status === 'success';

                if (isSuccessful) {
                    successCallback(response);
                } else {
                    const error = response.hasOwnProperty('message') ? response.message : 'An unknown error occurred after confirmation.';
                    this.$dynamicErrors.html(`<li>${error}</li>`);
                    this.$dynamicErrorsContainer.show();
                    forceCloseModal(this.$confirmPopup);
                }
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if ($('.changeProductStatus').length) {
        new ProductStatusManager();
    }
});